import { useFeature } from "../features";

export const useSubscriptionManagementEnabled = () => {
  const { featureEnabled } = useFeature();

  return featureEnabled("enable_subscription_management");
};
